import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { ApocalypseFreespinIdlePresentation } from "../freespin/ApocalypseFreespinIdlePresentation";

export class ApocalypseSuperFreespinIdlePresentation extends ApocalypseFreespinIdlePresentation {
    constructor() {
        super(`ApocalypseSuperFreespinIdlePresentation`);
    }

    protected get gameMode(): AbstractGameMode {
        return AbstractGameMode.SUPER_FREESPIN;
    }
}
